<template>
    <div :class="['ThePage',className]">
        <div class="ThePage__header">
            <slot name="left-action"></slot>
            <div class="ThePage__header-title">
                {{translate(title)}}
            </div>
            <slot name="right-action"></slot>
        </div>
        <slot></slot>
        <div class="ThePage__bottom-color"></div>
    </div>
</template>

<script>
    export default {
        name: 'ThePage',
        props: {
            //Title of the page
            title: {
                type: String
            },
            //Additional css class name for styling
            className: {
                type: String
            }
        }
    };
</script>

<style>
    .ThePage {
        width: 100%;
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }

    .ThePage__header {
        display: flex;
        flex-direction: row;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,.14);
        padding: 20px 28px;
        background-color: #455a64;
        color: #fff;
        margin: 0;
        line-height: 2rem
    }

    @media (max-width: 600px) {
        .ThePage__header {
            padding: 16px
        }
    }

    .ThePage__header-title {
        -webkit-font-smoothing: antialiased;
        font-size: 1.25rem;
        font-weight: 500;
        letter-spacing: .02em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1 1 auto;
        margin-left: 16px;
    }

    @media (max-width: 600px) {
        .ThePage__bottom-color {
            flex: 1 1 auto;
            background-color: #607d8b;
        }
    }
</style>



// WEBPACK FOOTER //
// ThePage.vue?4354e0ce